import * as React from 'react';
import { ContentWidget } from '../../widgets/ContentWidget';
import { PageWidget } from '../../widgets/layout/PageWidget';
import styled from '@emotion/styled';
import { fade_in_left } from '../../animations';

const schema_editing = require('../../../media/rapid-code/schema-editing.jpg');
export const RapidCodePage: React.FC = () => {
  return (
    <PageWidget title="Rapid-Code">
      <ContentWidget>
        <h1>What is Rapid-Code?</h1>
        <h2>Ultra-Fast App Development For Software Developers.</h2>
        <p>
          Building apps with low-code/no-code quickly becomes unwieldy and slow when app complexity increases. Pro-code
          is often too slow and expensive. That’s why we created an entirely new breed of app development platform:
        </p>
        <h2>Rapid-Code: The Best of Both Worlds</h2>
        <p>
          A groundbreaking 'Rapid-Code' paradigm of app development: The high-productivity benefits of a low-code
          platform, with the full power and flexibility of code as a first-class citizen. Small teams of software
          engineers are supercharged to conquer the app backlog.
        </p>
        <S.Video loop autoPlay muted playsInline>
          <source src="/public/vids/rapidcode.mp4" type="video/mp4" />
        </S.Video>
        <h2>Speed & Efficiency of Low-Code</h2>
        <p>
          Low-code/no-code platforms are fast and productive for simple apps, but become unwieldy and slow with more
          complex apps, have bad vendor lock-in, and are often opposed by developers.
        </p>
        <h2>Power & Flexibility of Pro-Code</h2>
        <p>
          Traditional professional development tools offer all the flexibility and power in the world — but they’re
          often too slow, and developer talent is scarce — so it's hard to scale them to meet a huge and growing demand
          for apps.
        </p>
        <h2>Secure, Scalable, Integrates With Everything</h2>
        <p>
          The JourneyApps Platform is an enterprise-grade stack that readily supports your mission-critical business
          apps:
        </p>
        <ul>
          <li>
            SOC 2 approved security with encryption of data in all states, source code encryption, extensive audit
            trails, SSO integration, GDPR/CCPA compliance tools, data ACLs, and more.
          </li>
          <li>
            “Any-to-any” custom integration by simply writing secure JavaScript or TypeScript serverless tasks — plus, a
            comprehensive REST API system and SQL data access.
          </li>
          <li>Turnkey cloud-native infrastructure with one-click deployment and infinite scalability.</li>
        </ul>
        <img src={schema_editing} />
      </ContentWidget>
    </PageWidget>
  );
};

namespace S {
  export const Video = styled.video`
    border-radius: 10px;
    overflow: hidden;
    width: 100%;
    box-shadow: 0 0 50px rgba(0, 0, 0, 0.5);
    ${fade_in_left};
    margin-top: 30px;
    margin-bottom: 30px;
  `;
}
